import { memo } from 'react';
import { GPTBanner } from './GPTBanner';
import { useApiContext } from 'react-easyrocket';
import { GPTBannerHeadless, GPTBannersContainer } from 'src/EXPERIMENTAL_LIB/modules/gpt/banners';
import { useEvent } from 'src/context/usePromoEvent';
import { useSettings } from 'src/modules/settings';
import { useDrawer } from 'src/hooks/useDrawer';
import { WheelEventIcon } from '../../gpt/components/GPTEventIcons/WheelEventIcon';
import { PigeonEventIcon } from '../../gpt/components/GPTEventIcons/PigeonEventIcon';
import { CardEventIcon } from 'src/modules/gpt/components/GPTEventIcons/CardEventIcon';

export const GPTBanners = memo(function GPTBanners() {
  const { isAuthenticated } = useApiContext();
  const { isCookiesAccepted } = useSettings();
  const { isLeftDrawerOpen } = useDrawer();
  const headerCookiesOffset =
    document.querySelector<HTMLElement>('.cookie-banner-wrapper')?.offsetHeight || 0;
  const { eventActive } = useEvent();
  const isEvent = eventActive.eventDays;
  const isEventWheel = eventActive.eventWheel;
  const isEventPigeon = eventActive.eventPigeon;
  const isEventPigeonSecond = eventActive.eventPigeonSecond;
  if (!isAuthenticated) return null;

  const bottomClass = !isCookiesAccepted ? `${headerCookiesOffset + 16 + 75}px` : '90px';

  return (
    <GPTBannersContainer>
      <div
        className="fixed right-2 1024:bottom-1/2 z-[650] gap-5 flex flex-col"
        style={{
          bottom: bottomClass,
          filter: `${isLeftDrawerOpen ? ' blur(5px) brightness(50%)' : 'none'}`
        }}>
        {isEventPigeon || isEventPigeonSecond ? (
          <GPTBannerHeadless
            gameName="birdGame"
            renderBanner={(props) => (
              <GPTBanner
                {...props}
                title="gptBanners.eventLuckyPigeonTitle"
                Icon={PigeonEventIcon}
              />
            )}
            key="birdGame"
          />
        ) : (
          <GPTBannerHeadless
            gameName="cardGame"
            renderBanner={({ Icon, ...props }) => (
              <GPTBanner {...props} Icon={isEvent ? CardEventIcon : Icon} />
            )}
            key="cardGame"
          />
        )}
        <GPTBannerHeadless
          gameName="wheelOfFortune"
          renderBanner={({ title, Icon, ...props }) => (
            <GPTBanner
              {...props}
              Icon={isEventWheel ? WheelEventIcon : Icon}
              title={isEventWheel ? 'gptBanners.eventWheelOfFortuneTitle' : title}
            />
          )}
          key="wheelOfFortune"
        />
      </div>
    </GPTBannersContainer>
  );
});
